<script lang="ts">
	import { fade } from 'svelte/transition';
	import { sharedConfig } from '$lib/animations';
</script>

<div in:fade={{ ...sharedConfig, delay: 1000 }} class="no-result">
	<h2 class="text:h2">Intet resultat fundet</h2>
	<p class="text:body">
		Vi kunne desværre ikke finde noget, der matcher din søgning. Prøv eventuelt at søge med andre
		ord eller justere din forespørgsel for bedre resultater.
	</p>
</div>

<style lang="scss">
	.no-result {
		position: relative;
		width: 100%;
		grid-column: 1 / -1;
		margin-top: var(--spacing-auto);

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		p {
			margin-top: $gap4;
			max-width: 36em;
			text-align: center;
		}
	}
</style>
